import createVueComponent from '../createVueComponent';

const FileCode = createVueComponent('FileCodeIcon', [
  [
    'path',
    {
      d: 'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z',
      key: '1nnpy2',
    },
  ],
  ['polyline', { points: '14 2 14 8 20 8', key: '1ew0cm' }],
  ['path', { d: 'm10 13-2 2 2 2', key: '17smn8' }],
  ['path', { d: 'm14 17 2-2-2-2', key: '14mezr' }],
]);

export default FileCode;
